import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=660192dc&scoped=true"
import script from "./orderList.vue?vue&type=script&lang=js"
export * from "./orderList.vue?vue&type=script&lang=js"
import style1 from "./orderList.vue?vue&type=style&index=1&id=660192dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660192dc",
  null
  
)

export default component.exports